// extracted by mini-css-extract-plugin
module.exports = {"promotedUrl":"styles_promotedUrl__F3F9j","urlsTooltip":"styles_urlsTooltip__0lBDr","scrollable":"styles_scrollable__HV7Iw"};